import { IconSparkles } from '../components/icons.jsx';

// Floating launcher rendered when the PRIME Copilot drawer is closed.
// Sparkle-only circular FAB docked at the bottom-right viewport edge, outside
// the centered content column so it never overlaps page cards. Click reopens
// the drawer. CSS in appShell.css handles the collision rule with the activity
// rail (shifts left when .app-shell.activity-rail-open).
export function PrimeCopilotLauncher({ onOpen }) {
  return (
    <button
      type="button"
      className="prime-copilot-launcher"
      onClick={onOpen}
      aria-label="Open PRIME Copilot — ask questions or get help"
      title="Ask PRIME"
      data-testid="prime-copilot-launcher"
      data-tour="copilot-launcher"
    >
      <span className="prime-copilot-launcher__icon" aria-hidden>
        <IconSparkles size={15} />
      </span>
      <span className="prime-copilot-launcher__label">Ask PRIME</span>
    </button>
  );
}
